module.exports = __webpack_public_path__ + "img/laptop-one.932ea62b.png";